import { CustomEventWithDetail, html, on, View } from 'rune-ts';
import klass from './ButtonColorChip.module.scss';
import { cx, cxIf } from '../util';

export interface ButtonColorChipData {
  color: string;
  secondColor?: string;
  selected: boolean;
  name?: string;
  disabled?: boolean;
  isGradient?: boolean;
  id?: number;
}

export type ButtonColorChipClickEventDetail = {
  color: string;
  secondColor?: string;
  name?: string;
  is_more_button: boolean;
  id?: number;
};

export class ButtonColorChipClickEvent extends CustomEventWithDetail<ButtonColorChipClickEventDetail> {}

export class ButtonColorChip extends View<ButtonColorChipData> {
  protected get selected() {
    return this.data.selected;
  }

  protected get color() {
    return this.data.color;
  }

  protected get secondColor() {
    return this.data.secondColor;
  }

  protected get name() {
    return this.data.name;
  }

  protected get id() {
    return this.data.id;
  }

  override template() {
    const { isGradient } = this.data;

    let style = '';
    if (this.secondColor) {
      style = `background-image: linear-gradient(135deg, ${this.color} 50%, ${this.secondColor} 50%);`;
    } else if (isGradient || this.color.includes('linear-gradient')) {
      style = `background-image: ${this.color}`;
    } else {
      style = `background-color: ${this.color}`;
    }

    return html`
      <div class="${cx(klass.button_color_chip, cxIf(isGradient, klass.with_more_button))}">
        <button
          style="${style}"
          class="${cx(klass.color_option, cxIf(this.selected, klass.selected))}"
          data-color="${this.color}"
          data-second-color="${this.secondColor || ''}"
          data-name="${this.name}"
          data-id="${this.id || ''}"
        ></button>
        ${isGradient ? html`<span class="${klass.more_button}"> ${TT('common::view_more')}</span>` : ''}
      </div>
    `;
  }

  setToggle(selected: boolean) {
    this.data.selected = selected;
    this.redraw();
  }

  @on('click')
  _onClick() {
    if (!this.data.selected) {
      this.setToggle(!this.selected);
    }
    this.dispatchEvent(ButtonColorChipClickEvent, {
      bubbles: true,
      detail: {
        color: this.color,
        secondColor: this.secondColor,
        name: this.name,
        id: this.id,
        is_more_button: this.element().classList.contains(klass.with_more_button),
      },
    });
  }
}
